"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[246],{

/***/ 246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditorialPartnersBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2153);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



// Cor de fundo padrão quando a editoria não define `cor` no Directus. Tom escuro
// (igual ao CT Eletro legado) para manter legível o rótulo claro "Conteúdo
// apoiado por:". Editorias devem cadastrar a cor de marca em Editorias.cor.
var COR_PADRAO = "#1C1C1C";
// Garante protocolo no link do parceiro: o cadastro no Directus aceita URLs sem
// esquema (ex.: "www.kabum.com.br"), que o browser interpretaria como rota
// relativa. Prefixa https:// quando não houver protocolo.
var normalizePartnerUrl = function(link) {
    return /^https?:\/\//i.test(link) ? link : "https://".concat(link);
};
/**
 * Banner/tarja da editoria da matéria (modelo Directus): caixa com a cor de
 * marca da editoria + logo da editoria à esquerda. Quando há parceiros
 * cadastrados, exibe também "Conteúdo apoiado por:" + logos à direita.
 *
 * Único banner de editoria da página interna (não há mais caminho hardcoded por
 * marca). A tarja identifica a editoria pela LOGO: sem logo cadastrada no
 * Directus → editoria sem identidade visual → não renderiza tarja, independente
 * de haver parceiro. Isso evita a "tarja preta sem logo" das editorias novas.
 */ function EditorialPartnersBanner(param) {
    var editoria = param.editoria, parceiros = param.parceiros, className = param.className;
    var ref;
    var comLogo = (parceiros !== null && parceiros !== void 0 ? parceiros : []).filter(function(parceiro) {
        var ref;
        return (ref = parceiro.logo) === null || ref === void 0 ? void 0 : ref.url;
    });
    var editoriaLogo = editoria === null || editoria === void 0 ? void 0 : (ref = editoria.logo) === null || ref === void 0 ? void 0 : ref.url;
    if (!editoriaLogo) return null;
    var cor = (editoria === null || editoria === void 0 ? void 0 : editoria.cor) || COR_PADRAO;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("isInternal flex flex-col items-center justify-center gap-4 rounded-t-lg rounded-b-none p-4 tablet:flex-row tablet:justify-between tablet:pb-6 [&>a]:h-8", className),
        style: {
            backgroundColor: cor
        },
        children: [
            editoriaLogo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "flex items-center",
                href: "/".concat(editoria.slug, "/"),
                title: editoria.nome,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    src: editoriaLogo,
                    alt: editoria.nome,
                    height: 33,
                    width: 108,
                    objectFit: "object-contain",
                    rounded: false
                })
            }),
            comLogo.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-before": "Conte\xfado apoiado por:",
                className: "flex flex-col text-sm before:block before:text-mglGray50 before:content-[attr(data-before)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2 flex flex-wrap justify-center gap-4",
                    children: comLogo.map(function(parceiro) {
                        var logo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            src: parceiro.logo.url,
                            alt: parceiro.nome,
                            height: 33,
                            width: 108,
                            objectFit: "object-contain",
                            rounded: false
                        });
                        if (!parceiro.link) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "z-[2] flex items-center",
                                children: logo
                            }, parceiro.id);
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "z-[2] flex items-center",
                            href: normalizePartnerUrl(parceiro.link),
                            rel: "sponsored",
                            title: "Ir para o site de ".concat(parceiro.nome),
                            target: "_blank",
                            children: logo
                        }, parceiro.id);
                    })
                })
            })
        ]
    });
}


/***/ })

}]);